export const AUTH_PATHS = [
  "/login",
  "/sign-up",
  "/signup",
  "/reset-password",
  "/new-password",
  "/verify-email",
];

export const getSafeRedirect = (from: any): string => {
  const path = typeof from === "string" ? from : from?.pathname;

  if (
    typeof path === "string" &&
    path.startsWith("/") &&
    !path.startsWith("//") &&
    !AUTH_PATHS.some((p) => path.startsWith(p))
  ) {
    if (typeof from === "object" && from !== null) {
      return `${from.pathname ?? ""}${from.search ?? ""}${from.hash ?? ""}`;
    }
    return path;
  }

  return "/profile";
};
